

import Handlers from './handlers';
import ApiProvider from './../apis/ApiProvider';
export default function registerEvents() {
    const api = ApiProvider.getEventApi();
    for (const handler of Handlers) {
        handler(api);
    }
}
